import PaypalPay from './paypal-pay';

export default PaypalPay;
